import React from 'react';
interface SectionHeadingProps {
  id: string;
  overline: string;
  titulo: string;
  descricao?: string;
}
export function SectionHeading({
  id,
  overline,
  titulo,
  descricao
}: SectionHeadingProps) {
  return <div className="mb-6" data-id="element-109" data-mp="3f1vix8av1xar">
      <p className="eyebrow text-[10px] font-medium text-mocha" data-id="element-110" data-mp="3f2n7hz61iurj">{overline}</p>
      <h2 id={id} className="mt-2.5 font-display text-[30px] leading-[1.1] text-ink" data-id="element-111" data-mp="3k186xwdgxaex">
        {titulo}
      </h2>
      {descricao && <p className="mt-2 text-[13.5px] leading-relaxed text-muted" data-id="element-112" data-mp="bl59skjzf44u">{descricao}</p>}
    </div>;
}